var React = require('react');

function StreamlineLine6EmailSend1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M23.5 1.5L.5 11l9 3.5z","key":0}),React.createElement("path",{"d":"M23.5 1.5l-4 18.5-10-5.5zM9.5 14.5v8l3.5-6","key":1})]),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine6EmailSend1.displayName = "StreamlineLine6EmailSend1";

StreamlineLine6EmailSend1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine6EmailSend1;

StreamlineLine6EmailSend1.default = StreamlineLine6EmailSend1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-6-email-send-1.svg
// module id = 771
// module chunks = 0